import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "font-bold text-red-600"
};
const _hoisted_2 = {
  class: "font-bold text-green-600"
};
const _hoisted_3 = {
  class: "font-bold"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyExchangeNotification',
  props: {
    notification: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_i18n_t = _resolveComponent("i18n-t");
      return _openBlock(), _createBlock(_component_i18n_t, {
        keypath: "you_exchanged_x_coins_for_y_currency"
      }, {
        coins: _withCtx(() => [_createElementVNode("span", _hoisted_1, "-" + _toDisplayString(__props.notification.payload.coins), 1)]),
        balanceGain: _withCtx(() => [_createElementVNode("span", _hoisted_2, "+" + _toDisplayString(__props.notification.payload.balanceGain), 1)]),
        type: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.notification.payload.type), 1)]),
        _: 1
      });
    };
  }
});